import { render, staticRenderFns } from "./onlineMatch.vue?vue&type=template&id=0b00fd8a"
import script from "./onlineMatch.vue?vue&type=script&lang=js"
export * from "./onlineMatch.vue?vue&type=script&lang=js"
import style0 from "./onlineMatch.vue?vue&type=style&index=0&id=0b00fd8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports